import { useEffect, useState } from "react";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

type Options = {
  defaultValues?: String[];
  onError?: () => void;
};

export const useFormErrors = (
  isError: boolean,
  error: FetchBaseQueryError | SerializedError | undefined,
  options?: Options
) => {
  const [formErrors, setFormErrors] = useState<String[] | any>([]);

  useEffect(() => {
    if (isError) {
      options?.onError && options.onError();
      const errData = (error as any).data;

      if (errData) {
        const errList = Object.values(errData);
        setFormErrors(errList.flat(1));
        return;
      }

      const errorStatus = (error as any).status;

      if (errorStatus) {
        setFormErrors([`Error ${errorStatus}`]);
      }
    }
  }, [isError, error, options]);

  useEffect(() => {
    if (options?.defaultValues) {
      setFormErrors(options.defaultValues);
    }
  }, [options?.defaultValues]);

  return formErrors;
};
